import script from "./RecepiesList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecepiesList.vue?vue&type=script&setup=true&lang=js"

import "./RecepiesList.vue?vue&type=style&index=0&id=cb96e95e&lang=css"

const __exports__ = script;

export default __exports__